import { faIndustry, faBuilding, faHome, faSolarPanel } from '@fortawesome/free-solid-svg-icons';

const services = [
    { 
        name: 'Industrial', 
        description: 'Professional industrial electrical services with a focus on safety and reliability.', 
        iconClass: faIndustry,
        serviceItems: [
            'Installation Services',
            'Maintenance & Repairs',
            'LV & MV Reticulation',
            'Pump & Motor Control Systems',
            'HVAC & Fire System Integration',
            'Thermal Scanning',
            'Preventative Maintenance'
        ]
    },
    { 
        name: 'Commercial', 
        description: 'Complete electrical solutions for commercial properties and businesses.', 
        iconClass: faBuilding,
        serviceItems: [
            'Installation Services',
            'Maintenance & Repairs',
            'Energy-Efficient Lighting',
            'Data Cabling & Networking',
            'HVAC & Fire System Integration',
            'Indoor & Outdoor Signage'
        ]
    },
    { 
        name: 'Domestic', 
        description: 'Reliable electrical services for your home and residential property.', 
        iconClass: faHome,
        serviceItems: [
            'Installation Services',
            'Maintenance & Repairs',
            'Geyser Elements & Timers',
            'Temperature Control Systems',
            'Garden & Landscape Lighting',
            'Water Storage & Irrigation'
        ]
    },
    { 
        name: 'Backup & Energy Efficient Power Solutions', 
        description: 'Modern power solutions for energy efficiency and backup power.', 
        iconClass: faSolarPanel,
        serviceItems: [
            'Installation & Maintenance',
            'Inverter & Battery Systems',
            'Solar Systems',
            'LED Retrofit Lighting',
            'Automated & Manual Generators'
        ]
    }
];

export {
    services
};